import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import "./success.css";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Success() {
  const [session, setSession] = useState(null);
   const query = useQuery();
  const sessionId = query.get('session_id');

  useEffect(() => {
    if (sessionId) {
      fetch(global.API_STRIPEAPI_URL+`session-details?session_id=${sessionId}`)
        .then((res) => res.json())
        .then((data) => {
          // sub.status,
          //       session.expires_at * 1000,
          let _userSession = localStorage.getItem("vs_UserSession");
          if (_userSession != undefined || _userSession != null) {
            _userSession = JSON.parse(_userSession);
            _userSession.subscriptionStatus = 'active';
            _userSession.subscriptionEndDate = data.expires_at * 1000;
            localStorage.setItem('vs_UserSession', JSON.stringify(_userSession));
          }
          setSession(data)
        })
        .catch((err) => console.error(err));
    }
  }, [sessionId]);

  if (!session) {
    return (
      <div className="flex justify-center items-center min-h-screen text-lg">
        Loading...
      </div>
    );
  }


 const formattedDate = new Date(session.expires_at * 1000).toLocaleString("en-IN");

  return (
    <div className="invoice-wrapper">
      <div className="invoice">
        <div className="invoice-header">
          <img
            src="https://www.vyavsay.in/websiteFilesFolder/img/logo.png"
            alt="Company Logo"
            className="invoice-logo"
          />
          <h1>Payment Receipt</h1>
          <p className="invoice-success">Thank you for your payment!</p>
        </div>

        <div className="invoice-details">
          <div className="invoice-row">
            <strong>Customer Email:</strong> {session.customer_details.email}
          </div>
          <div className="invoice-row">
            <strong>Payment Status:</strong> {session.payment_status}
          </div>
          <div className="invoice-row">
            <strong>Amount Paid:</strong> ₹{(session.amount_total / 100).toFixed(2)}
          </div>
          <div className="invoice-row">
            <strong>Currency:</strong> {session.currency.toUpperCase()}
          </div>
          <div className="invoice-row">
            <strong>Payment Mode:</strong> {session.payment_method_types.join(", ")}
          </div>
          <div className="invoice-row">
            <strong>Expires At:</strong> {formattedDate}
          </div>
          <div className="invoice-row">
            <strong>Customer:</strong> {session.customer}
          </div>
          {session.subscription && (
            <div className="invoice-row">
              <strong>Subscription ID:</strong> {session.subscription}
            </div>
          )}
        </div>

        <div className="invoice-footer">
          <p>Need help? Contact support at support@vyavsay.in</p>
        </div>
      </div>
      <div className="button-wrapper">
        <button onClick={() => window.print()} className="print-button">
        🖨️ Print Receipt
      </button>
      <button onClick={() => window.location.href = global.webUrl+'business/dashboard/'} className="home-button">
        🏠 Go to Home
      </button>
      </div>
    </div>
  );
};



export default Success;